// removed by extract-text-webpack-plugin
module.exports = {"waterWave":"waterWave___dakJM","text":"text___21YpJ"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/WaterWave/index.less
// module id = 431
// module chunks = 0 1